import { useLoaderData, useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Product } from '@/services/matching.service';
import ProductDetailContent from './components/ProductDetailContent';
import HomeContainer from '../Home/HomeContainer';
import Nav from '../Home/Nav';
import Footer from '../Home/Footer';

const ProductDetailPage = () => {
    const product = useLoaderData() as Product;
    const { vendorPath } = useParams();
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(`/${vendorPath}`);
    };

    if (!product) {
        return null;
    }

    return (
        <>
            <Helmet>
                <title>{product.groupTitle} - DDM Live 도매몰</title>
                <meta name="og:title" content={product.groupTitle}></meta>
                <meta name="description" content={product.description || 'DDM Live 도매몰'}></meta>
                <meta name="og:description" content={product.description || 'DDM Live 도매몰'}></meta>
            </Helmet>
            <HomeContainer>
                <Nav />
                <ProductDetailContent product={product} vendorPath={vendorPath} onBack={handleBack} />
                <Footer />
            </HomeContainer>
        </>
    );
};

export default ProductDetailPage;
